'use client'
import React from 'react'
import Image from 'next/image'
import { components } from 'react-select'

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <Image
        src="/img/icons/dropdownArrow.svg"
        width={15}
        height={10}
        alt="arrow"
      />
    </components.DropdownIndicator>
  )
}

export default DropdownIndicator
